<template>

    <div class="max-w-4xl px-4 py-10 mx-auto lg:py-20 sm:gap-y-0">


        <div>
            <nuxt-img class="mx-auto" src="/assets/images/optimize.jpg" width="766" height="431" format="webp"
            loading="lazy" sizes="xs:340px sm:450ppx md:766px lg:1023px xl:1200px" />
        </div>

        <div class="flex flex-col items-center justify-center mt-6 text-base text-center sm:flex-row md:mt-12 md:text-lg gap-x-4 font-ww-regular">
            Use Mindflow To Support THIS:

            <svg class="hidden w-12 mt-1 sm:w-32 lg:w-auto md:w-48 sm:block" width="247" height="16" viewBox="0 0 247 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M246.707 8.70713C247.098 8.3166 247.098 7.68344 246.707 7.29291L240.343 0.928953C239.953 0.538429 239.319 0.538429 238.929 0.928953C238.538 1.31948 238.538 1.95264 238.929 2.34317L244.586 8.00002L238.929 13.6569C238.538 14.0474 238.538 14.6806 238.929 15.0711C239.319 15.4616 239.953 15.4616 240.343 15.0711L246.707 8.70713ZM0 8L-8.74228e-08 9L246 9.00002L246 8.00002L246 7.00002L8.74228e-08 7L0 8Z" fill="black"/>
</svg>

<svg class="sm:hidden" width="16" height="42" viewBox="0 0 16 66" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.70701 65.7071C8.31648 66.0976 7.68332 66.0976 7.29279 65.7071L0.928841 59.3431C0.538318 58.9526 0.538319 58.3194 0.928844 57.9289C1.31937 57.5384 1.95253 57.5384 2.34306 57.9289L7.9999 63.5858L13.6568 57.9289C14.0473 57.5384 14.6805 57.5384 15.071 57.9289C15.4615 58.3195 15.4615 58.9526 15.071 59.3432L8.70701 65.7071ZM8.00001 1.16634e-06L9.00001 2.79222e-06L8.9999 65L7.9999 65L6.9999 65L7.00001 -4.59547e-07L8.00001 1.16634e-06Z" fill="black"/>
</svg>








And You Can Optimize THIS: 

        </div>

        <div class="mt-12 lg:ml-16">
            <nuxt-img class="mx-auto " src="/assets/images/schema-support.png" width="889" height="355" format="webp"
            loading="lazy" sizes="xs:340px sm:450ppx md:766px lg:1023px xl:1200px" />

            <!-- <nuxt-img class="block mx-auto md:hidden" src="/assets/images/schema-support.png" width="924" height="1136" format="webp"/> -->
        </div>



    </div>

</template>